export default __webpack_public_path__ + "static/media/Background 5_00068.94568aaa.png";